export const searchFields = ['name', 'description', 'tags'];

export enum PoliciesTabs {
  Library = 'library',
  CustomPolicies = 'customPolicies',
}

export const showAllTagName: string = 'Show All';
